<template>
  <router-view />
</template>

<script>
import { nanoid } from "nanoid";

import { getDeviceUUID, setDeviceUUID } from "./_services/localstorage";

export default {
  created() {
    document.title = "green4T - PGI";
    const htmlEl = document.documentElement;
    htmlEl.setAttribute("lang", "pt-BR");
    this.generateDeviceUUID();
  },
  methods: {
    generateDeviceUUID() {
      if (!getDeviceUUID()) {
        setDeviceUUID(nanoid());
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Material+Icons");
@import url(https://fonts.googleapis.com/css?family=Roboto);

body {
  font-family: Roboto, sans-serif;
}
</style>
